export enum BusinessPartnerAdminsManagementRoutes {
  List = '',
  Register = 'register',
}
